import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */

// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx

import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N300 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Text } from '@atlaskit/primitives';
import { SpacerWrapper, capitalizeFirstLetter } from './quick-find-meta';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ConfluenceResultMetaWrapper = styled.span({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ConfluenceTypeWrapper = styled.span({
  color: "var(--ds-text-subtle, ".concat(N300, ")")
});
var BreadCrumbs = function BreadCrumbs(_ref) {
  var _ref$breadCrumbs = _ref.breadCrumbs,
    breadCrumbs = _ref$breadCrumbs === void 0 ? [] : _ref$breadCrumbs;
  if (breadCrumbs.length === 0) {
    return null;
  }

  // only allow 2 breadcrumbs
  // take the first and the last (if different)
  var twoBreadcrumbs = [];
  if (breadCrumbs.length > 2) {
    twoBreadcrumbs = [breadCrumbs[0], breadCrumbs[breadCrumbs.length - 1]];
  } else {
    twoBreadcrumbs = breadCrumbs;
  }
  return /*#__PURE__*/React.createElement(Inline, {
    separator: "/",
    space: "space.100"
  }, twoBreadcrumbs.map(function (_ref2, i) {
    var id = _ref2.id,
      title = _ref2.title;
    return /*#__PURE__*/React.createElement(Text, {
      color: "color.text.subtle",
      size: "small",
      key: id
    }, title);
  }));
};
export var ConfluenceResultMeta = function ConfluenceResultMeta(_ref3) {
  var resultContentType = _ref3.resultContentType,
    resultAncestors = _ref3.resultAncestors,
    resultSpace = _ref3.resultSpace;
  var breadcrumbs = getBreadcrumbs(resultAncestors, resultSpace);
  return /*#__PURE__*/React.createElement(ConfluenceResultMetaWrapper, null, /*#__PURE__*/React.createElement(ConfluenceTypeWrapper, null, "Confluence"), /*#__PURE__*/React.createElement(SpacerWrapper, null, "\u2022"), /*#__PURE__*/React.createElement(ConfluenceTypeWrapper, null, "".concat(capitalizeFirstLetter(resultContentType))), (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SpacerWrapper, null, "\u2022"), /*#__PURE__*/React.createElement(BreadCrumbs, {
    breadCrumbs: breadcrumbs
  })));
};
export var getBreadcrumbs = function getBreadcrumbs(ancestors, space) {
  var breadcrumbs = [];
  if (space) {
    var spaceBreadcrumb = {
      id: space === null || space === void 0 ? void 0 : space.id,
      title: space === null || space === void 0 ? void 0 : space.name
    };
    if (!ancestors || ancestors.length === 0) {
      breadcrumbs = [spaceBreadcrumb];
    } else if (ancestors.length >= 1) {
      // The first ancestor is a root node that shouldn't be rendered
      breadcrumbs = [spaceBreadcrumb].concat(_toConsumableArray(ancestors.slice(1)));
    }
  }

  // Filter out invalid breadcrumbs
  return breadcrumbs.filter(function (breadCrumb) {
    return breadCrumb.id && breadCrumb.title;
  });
};